import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import XCircleblack from "../../IconComponents/XCircleblack";
import {
  postDataWithBody,
  postDataWithBodyFrGIS,
} from "../../../Services/Services";
import {
  claimIndTask,
  completeIndiTask,
  completeIndivTask,
} from "../../../Services/EndPoints";
import { toast } from "react-toastify";
import { useKeycloak } from "@react-keycloak/web";

const TaskModalWithComment = (props) => {
  const {
    title,
    titleValue,
    show,
    handleToggle,
    size,
    popupLabel,
    buttonLabel,
    data,
    getMyTaskList,
    setShowPop,
  } = props;

  const [comment, setComment] = useState(data || "");
  const [error, setError] = useState("");
  const [isSaving, setIsSaving] = useState(false); // ✅ NEW STATE

  const { keycloak } = useKeycloak();

  const todayDate = new Date().toISOString().split("T")[0];

  // Validate comment length
  const validateCommentLength = () => {
    if (comment.length > 250) {
      setError("Maximum 250 characters are allowed.");
      return false;
    }
    setError("");
    return true;
  };

  // Handle comment change
  const handleCommentChange = (e) => {
    setComment(e.target.value);
    if (e.target.value.length > 250) {
      setError("Maximum 250 characters are allowed.");
    } else {
      setError("");
    }
  };

  async function saveConfigData() {
    if (!validateCommentLength()) {
      return;
    }

    setIsSaving(true); // ✅ Disable button immediately

    let input = {
      id: props.taskData.id,
      task_id: props.taskData.task_id,
      assignType: props.taskData.assign_type,
      assignTask: props.taskData.assign_task,
      description: comment,
      email: keycloak.idTokenParsed.email,
      taskStartDate: todayDate,
    };

    let input1 = {
      id: props.taskData.id,
      description: comment,
      taskCompletedDate: todayDate,
    };

    let res = null;

    try {
      if (props.taskData.task_status_code === "TASK_EXE_STATUS_NEW_TASK") {
        res = await postDataWithBody(claimIndTask, input, {});
      } else if (
        props.taskData.task_status_code === "TASK_EXE_STATUS_INPROGRESS"
      ) {
        res = await postDataWithBody(completeIndivTask, input1, {});
      }

      if (res && res.status === "success") {
        props.showSuccessMsg();
        toast.success(res.msg, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
      } else {
        toast.error(res?.msg || "Something went wrong", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
        setShowPop(false);
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      }
    } catch (err) {
      toast.error("Something went wrong", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    } finally {
      setIsSaving(false); // ✅ Re-enable button after API completes
      getMyTaskList();
    }
  }

  return (
    <Modal
      show={show}
      onHide={handleToggle}
      size={size}
      className="table__modal__popup"
      centered
    >
      <Modal.Header>
        <Modal.Title>
          {title}
          {titleValue}
        </Modal.Title>
        <XCircleblack
          className="cursor-pointer"
          onClick={handleToggle}
          width="1.5em"
          height="1.5em"
        />
      </Modal.Header>

      <Modal.Body>
        <div className="create__resource--popup">
          <div className="form-group">
            <label
              className="create__resource--label"
              htmlFor="tfld_config_value"
            >
              {popupLabel}
            </label>

            <div className="mb-2">
              <label className="label_txt mb-2">Description</label>
              <div className="mb-2">{props.taskData.description}</div>
            </div>

            <textarea
              placeholder="Write your action here"
              className="form-control"
              rows={5}
              id="modal_comment_txt_area"
              value={comment}
              onChange={handleCommentChange}
            />

            {error && <div className="text-danger mt-2">{error}</div>}
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <button
          onClick={saveConfigData}
          type="button"
          className="btn btn-success"
          style={{ backgroundColor: "#40B2B7" }}
          disabled={
            error !== "" ||
            comment.length === 0 ||
            isSaving
          }
        >
          {isSaving ? "Saving..." : buttonLabel}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default TaskModalWithComment;
